<template>
  <div id="orderItemView">
    <template v-if="showPage == 1">
      <el-row>
        <el-row class="operateBtn-wrap">
          <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="backToOrderView">返回</el-button>
          <el-button type="primary" v-if="permission.btn_order_doMRP && selectedOrder.canMrp" icon="el-icon-my-split" size="small" @click="showDoMrp">生产制单</el-button>
          <el-button size="small" v-if="permission.btn_order_closeOrder && orderState != 1 && orderState != 6 && !isClose" @click="closeOrder">关闭订单</el-button>
        </el-row>
        <el-row class="margin20">
          <el-col :span="3.1">
            <span class="label">订单号：</span>
            <span class="value">{{ selectedOrder.orderCode ? selectedOrder.orderCode : `&nbsp;` }}</span>
          </el-col>
          <el-col :span="3.1">
            <span class="label">下单日期：</span>
            <span class="value" v-if="selectedOrder.orderTime">{{ selectedOrder.orderTime }}</span>
            <span class="value" v-else>&nbsp;</span>
          </el-col>
          <el-col :span="3.1">
            <span class="label">交付日期：</span>
            <span class="value">{{ selectedOrder.deliverTime ? selectedOrder.deliverTime : `&nbsp;` }}</span>
          </el-col>
          <el-col :span="3.1">
            <span class="label">订单状态：</span>
            <span class="value">{{ selectedOrder.parseState ? selectedOrder.parseState : `&nbsp;` }}</span>
          </el-col>
        </el-row>
        <el-row class="margin20">
          <el-col class="y_remark_flex">
            <span class="label">订单备注：</span>
            <div class="value" style="width:80%">
              <span>{{ selectedOrder.remark ? selectedOrder.remark : `&nbsp;` }}</span>
            </div>
          </el-col>
        </el-row>

        <!-- 产品列表开始 -->
        <el-row class="order_product_table">
          <el-row class="order_item_title">产品列表</el-row>
          <el-row>
            <el-table class="order_table" max-height="250" :data="itemTableData" tooltip-effect="dark">
              <el-table-column prop="materialName" label="物料名称" min-width="120"></el-table-column>
              <el-table-column prop="materialCode" label="物料编码" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column prop="specification" label="物料型号" min-width="220" show-overflow-tooltip></el-table-column>
              <el-table-column v-if="optional.length > 0" v-for="item in optional" :label="item" width="100" :key="item" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.optional | showAttrValue(item) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="itemCount" label="数量" width="80" :formatter="showProcessCount" show-overflow-tooltip></el-table-column>
              <el-table-column prop="unitType" label="单位" width="60" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <span v-if="permission.btn_productionPlan_listBatchPartProcessByPartPlan" type="text" @click="orderItemView(scope.row)" size="mini" class="operBtn" style="margin-right:12px"
                    >进度查看</span
                  >
                  <span v-if="permission.btn_productionTask_updateList" @click="orderItemEdit(scope.row)" type="text" class="operBtn" size="mini">编排任务</span>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-row>
        <!-- 产品列表结束 -->

        <!-- 工单任务列表开始 -->
        <el-row class="order_part_table">
          <el-row>
            <el-col :span="2" class="order_item_title">生产任务列表</el-col>
            <el-col :span="12" style="margin-top: 20px;margin-bottom:10px">
              <el-button
                v-if="permission.btn_productionTask_doSplit"
                type="primary"
                :disabled="selectRowData && selectRowData.splitStatus >= 2 && permission.btn_productionTask_doSplit"
                @click="addSplit"
                >工单拆分</el-button
              >
              <el-button
                v-if="permission.btn_productionTask_cancelSplit"
                type="primary"
                :disabled="selectRowData && selectRowData.splitStatus >= 2 && permission.btn_productionTask_cancelSplit"
                @click="cancelSplit"
                >取消拆分</el-button
              >
              <el-button
                v-if="permission.btn_productionPlan_closeSplit"
                type="primary"
                :disabled="selectRowData && (selectRowData.splitStatus == 5 || selectRowData.splitStatus == 4)"
                @click="closeSplit"
                >关闭工单</el-button
              >
              <el-button type="primary" @click="showConfig">自定义配置</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-table :data="taskList" :cell-style="cellStyle" border ref="tableDataRef" @sort-change="sortChangeEvent">
              <el-table-column width="30" fixed key="1">
                <template slot-scope="scope">
                  <el-radio :label="scope.row.id" v-model="selectTaskId" @change="taskSelect($event, scope.row)"></el-radio>
                </template>
              </el-table-column>
              <el-table-column
                key="2"
                v-if="selectTableColumns.includes('productionBatchCode')"
                prop="productionBatchCode"
                :formatter="parseBatchCode"
                label="工单/子工单号"
                width="130"
                show-overflow-tooltip
                fixed
              ></el-table-column>
              <el-table-column
                key="3"
                v-if="selectTableColumns.includes('orderCode')"
                prop="orderCode"
                sortable="custom"
                label="源订单号"
                min-width="120"
                :formatter="parseOrderCode"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column key="4" v-if="selectTableColumns.includes('itemIndex')" prop="itemIndex" label="订单行" min-width="60" show-overflow-tooltip></el-table-column>
              <el-table-column key="5" v-if="selectTableColumns.includes('materialName')" prop="materialName" label="物料名称" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column key="6" v-if="selectTableColumns.includes('materialCode')" prop="materialCode" label="物料编码" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column key="7" v-if="selectTableColumns.includes('specification')" prop="specification" label="规格" min-width="70" show-overflow-tooltip></el-table-column>
              <el-table-column key="8" v-if="selectTableColumns.includes('splitCount')" prop="splitCount" label="数量" min-width="60" show-overflow-tooltip></el-table-column>
              <el-table-column key="9" v-if="selectTableColumns.includes('workshopName')" prop="workshopName" sortable="custom" label="机组" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope" v-if="selectTableColumns.includes('workshopName')">
                  <el-select
                    clearable
                    :disabled="itemCanEdit(scope.row)"
                    @change="editOrder($event, scope.row)"
                    filterable
                    v-model="scope.row.factoryModelId"
                    size="small"
                    maxlength="16"
                    placeholder="选择机组"
                  >
                    <el-option v-for="item in workershopList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column key="10" v-if="selectTableColumns.includes('tecId')" prop="tecId" sortable="custom" label="工艺路线" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope" v-if="selectTableColumns.includes('tecId')">
                  <el-select
                    v-if="selectTableColumns.includes('tecId')"
                    clearable
                    :disabled="itemCanEdit(scope.row)"
                    @change="editOrder($event, scope.row)"
                    filterable
                    v-model="scope.row.technologyId"
                    size="small"
                    maxlength="16"
                    placeholder="工艺路线"
                  >
                    <el-option :style="item.hasProcedure != 1 ? { color: 'red' } : {}" v-for="item in scope.row.tecList" :key="item.id" :label="item.routeName" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column key="11" v-if="selectTableColumns.includes('planStartTime')" sortable="custom" prop="planStartTime" label="计划开始时间" min-width="138">
                <template slot-scope="scope" v-if="selectTableColumns.includes('planStartTime')">
                  <el-date-picker
                    v-if="selectTableColumns.includes('planStartTime')"
                    :disabled="itemCanEdit(scope.row)"
                    :picker-options="pickerStartOption(scope.row)"
                    @change="editOrder($event, scope.row)"
                    style="width:128px"
                    width="120"
                    v-model="scope.row.planStartTime"
                    type="date"
                    format="yyyy-MM-dd"
                    placeholder="计划开始时间"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>

              <el-table-column key="12" v-if="selectTableColumns.includes('planEndTime')" prop="planEndTime" label="计划完工时间" min-width="138">
                <template slot-scope="scope" v-if="selectTableColumns.includes('planEndTime')">
                  <el-date-picker
                    v-if="selectTableColumns.includes('planEndTime')"
                    :disabled="itemCanEdit(scope.row)"
                    :picker-options="pickerEndOption(scope.row)"
                    @change="editOrder($event, scope.row)"
                    style="width:128px"
                    width="120"
                    v-model="scope.row.planEndTime"
                    type="date"
                    format="yyyy-MM-dd"
                    placeholder="计划完工时间"
                  ></el-date-picker>
                </template>
              </el-table-column>

              <el-table-column key="13" v-if="selectTableColumns.includes('splitStatus')" sortable="custom" prop="splitStatus" label="工单状态" min-width="96" show-overflow-tooltip>
                <template slot-scope="scope" v-if="selectTableColumns.includes('splitStatus')">
                  <span class="radius" :style="parseStatus(scope.row).radiusStyle"></span>
                  <span :style="parseStatus(scope.row).textStye">{{ parseStatus(scope.row).text }}</span>
                </template>
              </el-table-column>
              <el-table-column key="14" v-if="selectTableColumns.includes('postInOrder')" prop="postInOrder" label="App按序报工" show-overflow-tooltip width="100">
                <template slot-scope="scope" v-if="selectTableColumns.includes('postInOrder')">
                  <el-switch
                    v-if="selectTableColumns.includes('postInOrder')"
                    :disabled="itemCanEdit(scope.row)"
                    v-model="scope.row.postInOrder"
                    @change="editOrder($event, scope.row)"
                    active-color="#13ce66"
                    inactive-color="#ccc"
                  ></el-switch>
                </template>
              </el-table-column>

              <el-table-column
                key="15"
                v-if="selectTableColumns.includes('productionType')"
                prop="productionType"
                label="工单类型"
                :formatter="parseType"
                min-width="70"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                key="16"
                v-if="selectTableColumns.includes('gmtCreate')"
                prop="gmtCreate"
                label="创建时间"
                min-width="140"
                show-overflow-tooltip
                :formatter="$commonUtil.changeToDate"
              ></el-table-column>
              <el-table-column
                key="17"
                v-if="selectTableColumns.includes('gmtModified')"
                prop="gmtModified"
                label="更新时间"
                min-width="140"
                show-overflow-tooltip
                :formatter="$commonUtil.changeToDate"
              ></el-table-column>
              <el-table-column key="18" v-if="selectTableColumns.includes('updateUserName')" prop="updateUserName" label="最后操作人" min-width="60" show-overflow-tooltip>
                <template slot-scope="scope" v-if="selectTableColumns.includes('updateUserName')">
                  {{ scope.row.updateUserName }}
                </template>
              </el-table-column>
              <el-table-column
                key="19"
                v-if="selectTableColumns.includes('partProcessRatio')"
                prop="partProcessRatio"
                fixed="right"
                :formatter="parseProcess"
                label="工单进度"
                min-width="74"
                show-overflow-tooltip
              >
                <template slot-scope="scope" v-if="selectTableColumns.includes('partProcessRatio')">
                  <el-button v-if="selectTableColumns.includes('partProcessRatio')" type="text">{{ parseProcess(scope.row) }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-row>
        <!-- 工单任务列表结束 -->
      </el-row>
    </template>

    <template v-if="showPage == 2">
      <OrderItemView :selectedSplit="selectedSplit"></OrderItemView>
    </template>

    <template v-if="showPage == 3">
      <OrderItemEdit :allDeviceList="allDeviceList" :allWorkerSelect="allWorkerSelect" :allWorkershopList="allWorkershopList" :selectedSplit="selectedSplit"></OrderItemEdit>
    </template>

    <!-- 工单拆分开始 -->
    <el-dialog title="工单拆分" :visible.sync="showSplitDialog" :width="W ? '66%' : '80%'" :close-on-click-modal="false" center>
      <el-form :model="splitForm" ref="splitForm" style="width:100%;" class="add_form" :rules="rules">
        <el-row :gutter="20" style="margin-bottom:10px">
          <el-col :span="7">
            <span class="title">工单号：</span>
            <el-form-item class="value">
              <span>{{ splitForm.productionBatchCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <span class="title">生产数量：</span>
            <el-form-item class="value">
              <span>{{ splitForm.splitCount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <span class="title">物料编码：</span>
            <el-form-item class="value">
              <span>{{ splitForm.materialCode }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom:10px">
          <el-col :span="7">
            <span class="title">物料名称：</span>
            <el-form-item class="value">
              <span>{{ splitForm.materialName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <span class="title">物料类型：</span>
            <el-form-item class="value" style="max-width:180px">
              <span>{{ splitForm.splitItemType | formatteMaterialName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <span class="title">计划生产时间：</span>
            <el-form-item class="value" style="width:230px">
              <span>{{ splitForm | formatteTime }}&nbsp;</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button type="primary" @click="addSplitItem">新增拆分</el-button>
        </el-row>

        <el-table :data="splitOrderList" max-height="450" style="margin-top:10px">
          <el-table-column prop="itemName" label="序号" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-form-item>
                {{ scope.$index + 1 }}
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column label="拆分数量" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-form-item :prop="`splitOrderList[${scope.$index}]`" :rules="rules.splitCount">
                <el-input v-model="scope.row.splitCount" style="width:140px"></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="55">
            <template slot-scope="scope">
              <el-form-item>
                <div class="delete" type="primary" @click="deleteSplitItem(scope.$index)" v-if="splitOrderList.length != 1"></div>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div style="text-align: center; margin-top:20px">
        <el-button size="small" @click="showSplitDialog = false" style="margin-left: 20px;">取消</el-button>
        <el-button type="primary" size="small" @click="submitSplitOrder">确定</el-button>
      </div>
    </el-dialog>
    <!-- 工单拆分结束 -->

    <el-dialog title="配置列表显示字段" :visible.sync="configDialogVisisble" width="54%" @close="cancelConfig" :close-on-click-modal="false" center>
      <el-checkbox-group v-model="selectTableColumns">
        <el-checkbox style="margin-right: 0px; width: 25%;height: 50px;" v-for="item in tableColumnConfig" :label="item.key" :key="item.key" :disabled="item.disabled">{{ item.value }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer">
        <el-button type="primary" @click="updateConfig">确 定</el-button>
        <el-button @click="cancelConfig">取 消</el-button>
      </span>
    </el-dialog>

    <DoMRP :orderId="orderId" :isShow.sync="showMrp"></DoMRP>
  </div>
</template>

<script>
import DoMRP from "./DoMrp.vue";
import OrderItemEdit from "./OrderItemEdit.vue";
import OrderItemView from "./OrderItemView.vue";
import CommonUtil from "@/util/CommonUtils.js";
export default {
  name: "orderItemView",
  props: {
    selectedOrder: Object
  },
  data() {
    let that = this;
    return {
      showSplitDialog: false,
      splitForm: {},
      selectRowData: {},
      showMrp: false,
      orderId: null,
      workershopList: [],
      selectTaskId: null,
      orderTypeOptions: [
        { label: "正常生产", value: 0, id: 0 },
        { label: "加急生产", value: 1, id: 1 },
        { label: "外购", value: 2, id: 2 }
      ],
      optional: [],
      configDialogVisisble: false,
      selectTableColumns: [
        "productionBatchCode",
        "orderCode",
        "itemIndex",
        "materialName",
        "materialCode",
        "splitCount",
        "workshopName",
        "tecId",
        "planStartTime",
        "planEndTime",
        "splitStatus",
        "postInOrder",
        "productionType",
        "gmtCreate",
        "gmtModified",
        "partProcessRatio"
      ],
      tableColumnConfig: [
        { key: "productionBatchCode", value: "工单/子工单号", disabled: true, isShow: true },
        { key: "orderCode", value: "源订单号", disabled: false, isShow: true },
        { key: "itemIndex", value: "订单行", disabled: false, isShow: true },
        { key: "materialName", value: "物料名称", disabled: false, isShow: true },
        { key: "materialCode", value: "物料编码", disabled: true, isShow: true },
        { key: "specification", value: "规格", disabled: false, isShow: true },
        { key: "splitCount", value: "数量", disabled: false, isShow: true },
        { key: "workshopName", value: "机组", disabled: false, isShow: true },
        { key: "tecId", value: "工艺路线", disabled: true, isShow: true },
        { key: "planStartTime", value: "计划开始时间", disabled: false, isShow: true },
        { key: "planEndTime", value: "计划完工时间", disabled: false, isShow: true },
        { key: "splitStatus", value: "工单状态", disabled: false, isShow: true },
        { key: "postInOrder", value: "App按序报工", disabled: false, isShow: true },
        { key: "productionType", value: "工单类型", disabled: false, isShow: true },
        { key: "gmtCreate", value: "创建时间", disabled: false, isShow: true },
        { key: "gmtModified", value: "更新时间", disabled: false, isShow: true },
        { key: "updateUserName", value: "最后操作人", disabled: false, isShow: true },
        { key: "partProcessRatio", value: "工单进度", disabled: false, isShow: true }
      ],
      taskList: [],
      productionInfo: {
        produceAmount: 0,
        dataList: []
      },
      isShowDialog: false,
      splitAmount: 0,
      showSplitInfoDialog: false,
      height: "",
      selectList: [],
      printModelData: [],
      printForm: {
        modelType: 0,
        printModelData: []
      },
      showPrintDialog: false,
      loadPic: false,
      picData: [],
      addForm: {
        materialName: "",
        materialCode: "",
        unitOfQuantity: "",
        nameOfUnitType: "",
        alreadyInAmount: 0,
        couldInAmount: 0,
        batchList: [],
        warehouseId: null,
        remark: "",
        topWarehouseId: "",
        amount: 0,
        materialId: null,
        productionBatch: "",
        productionBatchId: null,
        timeOfStockIn: null
      },
      rules: {
        splitCount: [
          { required: false, message: "请输入每份数量", trigger: "blur" },
          {
            validator(rule, item, callback) {
              let value = item.splitCount;
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("拆分数量必须为数字"));
                } else {
                  if (value > 0) {
                    let len = (String(value).split(".")[1] || "").length;
                    if (len > 2) {
                      callback(new Error("拆分数量最多可保留2位小数"));
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("拆分数量必须大于零"));
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      showStoreDialog: false,
      ProductionPlanFlow: {},
      isUrgent: null,
      testId: [],
      splitOrderList: [],
      itemTableData: [],
      showSplitDialog: false,

      showPage: 1,
      selectedSplit: null,
      isClose: false,
      options: [
        { value: "0", label: "未开始" },
        { value: "4", label: "生产中" },
        { value: "1", label: "已完成" },
        { value: "3", label: "已关闭" },
        { value: "2", label: "已延期" },
        { value: "5", label: "未排产" },
        { value: "6", label: "延期完成" }
      ],
      orderState: null,
      orderStateText: "",
      W: false,
      allDeviceList: [],
      allWorkerSelect: [],
      allWorkershopList: [],
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  //el和data尚未初始化
  beforeCreate: function() {},

  //data初始化完成
  created: function() {},

  //el初始化完成
  beforeMount: function() {
    this.isUrgent = this.selectedOrder.isUrgent;
    this.loadBusinessOrderItem();
    this.initConfig();
    this.loadBusinessOrderPart();
    this.loadWorkShopList();
  },

  //完成挂载
  mounted: function() {
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    this.loadBaseData();
  },
  //更新dom时触发
  beforeUpdate: function() {},
  updated: function() {},
  activated: function() {},
  deactivated: function() {},
  beforeDestroy: function() {},
  destroyed: function() {},
  components: {
    OrderItemEdit,
    OrderItemView,
    DoMRP
  },
  computed: {},

  filters: {
    showAttrValue(arr, name) {
      if (!arr) {
        return "";
      } else {
        let find = false;
        let tmp = "";
        arr.forEach(item => {
          if (item.attrName == name && item.attrValue) {
            tmp = item.attrValue;
          }
        });
        return tmp;
      }
    },

    showType(value) {
      if (value == 0) {
        return "产品";
      } else if (value == 1) {
        return "零件";
      }
    },

    filterProductionType(value) {
      if (value == 1) {
        return "自产";
      } else if (value == 2) {
        return "外协";
      } else if (value == 3) {
        return "自产+外协";
      } else if (value == 4) {
        return "外购";
      }
    },

    formatteTime(item) {
      if (item.planStartTime && item.planEndTime) {
        let start = new Date(item.planStartTime).getTime();
        let end = new Date(item.planEndTime).getTime();
        return CommonUtil.timestampToDate(start, true) + " — " + CommonUtil.timestampToDate(end, true);
      } else {
        return "";
      }
    },

    formatteMaterialName(value) {
      let str = "";
      switch (value) {
        case 0:
          str = "产品";
          break;
        case 1:
          str = "零件";
          break;
        case 2:
          str = "原材料";
          break;
        default:
          str = "未知类型";
          break;
      }
      return str;
    }
  },
  methods: {
    // 1.初始化加载默认50条设备数据和用户数据
    loadBaseData() {
      this.$RequestUtil.post({
        url: "/api/select/productionAssignableDevice",
        params: { arrangedDevice: [], startDate: null, endDate: null, deviceType: null, deviceId: null },
        success: res => {
          if (res.code == 0) {
            this.allDeviceList = res.data;
          }
        }
      });
      this.$RequestUtil.post({
        url: "/api/select/listWorker",
        params: { limitCount: 50 },
        success: res => {
          if (res.code == 0) {
            this.allWorkerSelect = res.data;
          }
        }
      });
    },

    orderItemEdit(rowData) {
      let businessOrderItemId = rowData.id;
      this.selectedSplit = {
        orderCode: this.selectedOrder.orderCode,
        orderTime: this.selectedOrder.orderTime,
        deliverTime: this.selectedOrder.deliverTime,
        orderState: this.selectedOrder.orderState,
        parseStateText: this.selectedOrder.parseState,
        orderRowMaterialName: rowData.materialName,
        orderRowMaterialCode: rowData.materialCode,
        orderRowSpecification: rowData.specification,
        orderRowCount: rowData.itemCount,
        businessOrderItemId: rowData.id,
        remark: this.selectedOrder.remark
      };

      this.showPage = 3;
    },

    loadWorkShopList() {
      this.$RequestUtil.get({
        url: "/api/factoryModel/getWorkShopList",
        // type:'sync',
        params: {},
        success: res => {
          if (res.code == 0) {
            this.workershopList = res.data;
            this.allWorkershopList = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    orderItemView(rowData) {
      let businessOrderItemId = rowData.id;
      this.selectedSplit = {
        orderCode: this.selectedOrder.productionOrderCode ? this.selectedOrder.productionOrderCode : this.selectedOrder.orderCode,
        orderTime: this.selectedOrder.orderTime,
        deliverTime: this.selectedOrder.deliverTime,
        orderState: this.selectedOrder.orderState,
        parseStateText: this.selectedOrder.parseState,
        orderRowMaterialName: rowData.materialName,
        orderRowMaterialCode: rowData.materialCode,
        orderRowSpecification: rowData.specification,
        orderRowCount: rowData.itemCount,
        businessOrderItemId: rowData.id,
        remark: this.selectedOrder.remark
      };

      this.showPage = 2;
    },

    taskSelect(ev, row) {
      this.selectRowData = row;
    },

    submitSplitOrder() {
      this.$refs["splitForm"].validate(valid => {
        if (valid) {
          let index = 0;
          let countArr = [];
          let sum = 0;
          let last = 0;
          this.splitOrderList.forEach(item => {
            if (!item.splitCount) {
              index++;
            } else {
              countArr.push(Number(item.splitCount));
              sum += Number(item.splitCount);
            }
          });
          if (index > 1) {
            this.$message.warning("拆分数量最多只允许一组为空");
            return;
          }
          last = Math.round((this.splitForm.splitCount - sum) * 100) / 100;
          if (last < 0) {
            this.$message.warning(`拆分总量(${sum})不能大于生产数量(${this.splitForm.splitCount})`);
            return;
          } else if (last >= 0) {
            if (last != 0) {
              countArr.push(last);
            }
            if (countArr.length == 1) {
              this.$message.warning("拆分份数必须大于1,请修改拆分数量");
              return;
            }
            let len = countArr.length;
            let str = countArr.join(" , ");
            this.$confirm(`生产数量将会拆分为:${str}; ${len}份生产数量是否确认拆分?`, "提示", {
              cancelButtonClass: "btn-custom-cancel",
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              this.$RequestUtil.post({
                url: "/api/productionTask/doSplit",
                type: "sync",
                params: {
                  id: this.splitForm.id,
                  splitList: countArr
                },
                success: res => {
                  if (res.code == 0) {
                    this.loadBusinessOrderPart();
                    this.showSplitDialog = false;
                  } else {
                    this.$message.error(res.msg || res.message);
                  }
                }
              });
            });
          }
        }
      });
    },

    addSplit() {
      if (!this.selectRowData.id) {
        this.$message.warning("请选择需要拆分工单");
        return;
      }
      this.splitForm = CommonUtil.cloneObj(this.selectRowData);
      log(this.splitForm, 666);
      this.splitOrderList = [{}];

      this.splitForm.splitOrderList = this.splitOrderList;
      this.showSplitDialog = true;
    },

    cancelSplit() {
      if (!this.selectRowData.id) {
        this.$message.warning("请选择需要取消拆分工单");
        return;
      }
      this.$confirm(`此操作将会删除此工单,并将任务数量合并到其他工单上是否继续?`, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/productionTask/cancelSplit",
          type: "sync",
          params: {
            id: this.selectRowData.id
          },
          success: res => {
            if (res.code == 0) {
              this.loadBusinessOrderPart();
              this.$message.success("工单取消成功");
            } else {
              this.$message.error(res.msg || res.message);
            }
          }
        });
      });
    },

    addSplitItem() {
      this.splitOrderList.push({});
    },

    deleteSplitItem(index) {
      this.splitOrderList.splice(index, 1);
    },

    closeSplit() {
      if (!this.selectRowData.id) {
        this.$message.warning("请选择需要关掉工单");
        return;
      }
      this.$RequestUtil.post({
        url: "/api/productionPlan/closeSplit",
        type: "sync",
        params: {
          splitId: this.selectRowData.id
        },
        success: res => {
          if (res.code == 0) {
            this.loadBusinessOrderPart();
            this.$message.success("工单关闭成功");
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    showDoMrp() {
      this.orderId = this.selectedOrder.id;
      this.showMrp = true;
    },

    //根据订单状态判断工单是否可以编辑
    itemCanEdit(rowDate) {
      if (rowDate.splitStatus >= 2) {
        return true;
      } else {
        return false;
      }
    },

    parseStatus(rowDate) {
      let json = {
        text: "",
        textStye: {},
        radiusStyle: {}
      };
      switch (
        rowDate.splitStatus //0-未排产 1-已排产 2-已派工 3-生产中 4-已完成 5-已关闭
      ) {
        case 0:
          json.text = "未排产";
          json.textStye = {
            color: "#24d0f2"
          };
          json.radiusStyle = {
            background: "#f2331a"
          };
          break;
        case 1:
          json.text = "已排产";
          json.textStye = {};
          json.radiusStyle = {
            background: "#FAC916"
          };
          break;
        case 2:
          json.text = "已派工";
          json.textStye = {};
          json.radiusStyle = {
            background: "#24d0f2"
          };
          break;
        case 3:
          json.text = "生产中";
          json.textStye = {};
          json.radiusStyle = {
            background: "#71e2a3"
          };
          break;
        case 4:
          json.text = "已完成";
          json.textStye = {};
          json.radiusStyle = {
            background: "#409eff"
          };
          break;
        case 5:
          json.text = "已关闭";
          json.textStye = {
            color: "#02A7F0"
          };
          json.radiusStyle = {
            background: "#dddddd"
          };
          break;
      }
      return json;
    },

    async editOrder(ev, rowDate) {
      let res = await this.$RequestUtil.postAsync({ url: "/api/productionTask/updateList", params: { ...rowDate } });
      this.getMessage(res);
    },

    getMessage(res) {
      if (res && res.code == 0) {
        this.taskList.forEach(item => {
          if (item.id == res.data.id) {
            this.$set(item, "gmtModified", res.data.gmtModified);
            this.$set(item, "splitStatus", res.data.splitStatus);
            this.$set(item, "technologyState", res.data.technologyState);
          }
        });
      } else {
        this.$message.error(res.msg || res.message);
      }
    },

    pickerStartOption(row) {
      if (row.planEndTime) {
        return {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 || time.getTime() > row.planEndTime;
          }
        };
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        };
      }
    },

    pickerEndOption(row) {
      if (row.planStartTime) {
        return {
          disabledDate(time) {
            return time.getTime() < row.planStartTime;
          }
        };
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        };
      }
    },

    parseBatchCode(rowDate) {
      if (rowDate.childProductionBatchCode) {
        return rowDate.childProductionBatchCode;
      } else {
        return rowDate.productionBatchCode;
      }
    },

    parseOrderCode(row) {
      if (row.productionOrderCode) {
        return row.productionOrderCode;
      } else {
        return row.orderCode;
      }
    },

    parseProcess(rowDate) {
      if (rowDate.partProcessRatio != null) {
        return rowDate.partProcessRatio + "%";
      }
    },

    parseType(rowDate) {
      if (rowDate.productionType != null && rowDate.productionType != undefined) {
        return (this.orderTypeOptions.find(item => item.value == rowDate.productionType) || {}).label;
      }
    },

    initConfig() {
      let info = JSON.parse(localStorage.getItem("tableColumnConfigInfo"));
      if (!info) {
        info = { defaultTableColumnConfig: this.tableColumnConfig };
        localStorage.setItem("tableColumnConfigInfo", JSON.stringify(info));
      } else {
        let userId = localStorage.getItem("userId");
        if (info[userId]) {
          this.tableColumnConfig = info[userId];
        } else {
          this.tableColumnConfig = info.defaultTableColumnConfig;
        }
        this.selectTableColumns = this.tableColumnConfig.filter(item => item.isShow).map(item => item.key);
      }

      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    },

    updateConfig() {
      this.configDialogVisisble = false;
      this.tableColumnConfig.forEach(item => {
        if (this.selectTableColumns.includes(item.key)) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      });
      let info = JSON.parse(localStorage.getItem("tableColumnConfigInfo"));
      let userId = localStorage.getItem("userId");
      info[userId] = this.tableColumnConfig;
      localStorage.setItem("tableColumnConfigInfo", JSON.stringify(info));
      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    },

    cancelConfig() {
      this.selectTableColumns = this.tableColumnConfig.filter(item => item.isShow).map(item => item.key);
      this.configDialogVisisble = false;
    },

    showConfig() {
      this.configDialogVisisble = true;
    },

    headStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "head-cell-class";
      }
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "cell-class test-margin";
      } else {
        return "test-margin";
      }
    },

    createFilter(queryString) {
      return restaurant => {
        if (restaurant.productionBatch) {
          return restaurant.productionBatch.toLowerCase().indexOf(queryString.toLowerCase()) != -1;
        }
      };
    },

    checkRow(check) {
      if (check) {
        this.$RequestUtil.get({
          url: "/api/order/setCancelUrgentOrder",
          params: {
            orderId: this.selectedOrder.id,
            type: true
          },
          success: res => {
            if (res.code == 0) {
              this.isUrgent = true;
            }
          }
        });
      } else {
        this.$RequestUtil.get({
          url: "/api/order/setCancelUrgentOrder",
          params: {
            orderId: this.selectedOrder.id,
            type: false
          },
          success: res => {
            if (res.code == 0) {
              this.isUrgent = false;
            }
          }
        });
      }
    },

    closeOrder() {
      this.$confirm("是否关闭该订单?", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.get({
          url: "/api/order/closeOrder",
          type: "sync",
          params: {
            orderId: this.selectedOrder.id
          },
          success: async res => {
            if (res.code == 0) {
              this.$message.success("关闭成功");
              this.isClose = true;
            } else {
              this.$message.error(res.msg || res.message);
            }
          }
        });
      });
    },

    reload() {
      this.loadBusinessOrderItem(this.loadBusinessOrderPart);
      this.$forceUpdate();
    },

    backToOrderView() {
      this.$parent.oldPageNum = this.selectedOrder.pageNum;
      this.$parent.showPage = 0;
      this.$parent.orderColumn = this.selectedOrder.orderColumn;
      this.$parent.orderType = this.selectedOrder.orderType;
      this.$parent.reload(this.selectedOrder.pageNum, this.selectedOrder.orderColumn, this.selectedOrder.orderType);
    },

    loadBusinessOrderItem(fnCallback) {
      //加载商品

      this.$RequestUtil.get({
        url: "/api/order/listBusinessOrderItem",

        params: {
          orderId: this.selectedOrder.id
        },
        success: res => {
          if (res.code === 0) {
            let optional = [];
            res.data.forEach(item => {
              //剩余待拆解数量
              item.residueCount = item.itemCount - item.splitedCount;
              item.oldResidueCount = item.itemCount - item.splitedCount;
              if (item.optional && item.optional.length > 0) {
                item.optional = JSON.parse(item.optional);
                item.optional.forEach(opt => {
                  optional.push(opt);
                });
              }
              if (item.itemType === 0) {
                item.itemModel = item.itemCode;
              }
            });
            // fnCallback&&fnCallback(res.data);
            let arr = [];
            optional.forEach((item, index) => {
              let find = false;
              arr.forEach(key => {
                if (key == item.attrName) {
                  find = true;
                }
              });
              if (!find) {
                arr.push(item.attrName);
              }
            });

            this.itemTableData = res.data;
            this.optional = arr;
            //过滤掉待拆解数量为0的数据
            this.splitOrderList = res.data.filter(item => item.residueCount > 0);
          } else {
            this.$RequestUtil.loading().close();
          }
        }
      });
    },

    loadBusinessOrderPart() {
      //加载工单任务
      this.$RequestUtil.post({
        url: "/api/productionTask/list",
        type: "sync",
        params: {
          businessOrderId: this.selectedOrder.id
        },
        success: res => {
          // this.$RequestUtil.loading().close()
          if (res.code == 0) {
            log(res.data, 555);
            res.data.forEach(r => {
              (r.tecList || []).forEach(item => {
                if (item.hasProcedure == -1) {
                  item.routeName = item.routeName + "(工艺待审核)";
                } else if (item.hasProcedure == 0) {
                  item.routeName = item.routeName + "(暂无工艺)";
                }
              });
            });
            this.taskList = res.data;
            log(this.taskList, 8888);
          }
        }
      });
    },

    showProcessCount(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "-";
      }
      return cellValue;
    },

    sortChangeEvent(e) {}
  },
  watch: {}
};
</script>

<style scoped>
.show-icon {
  width: 14px;
  height: 14px;
  display: inline-block;
  background-size: cover;
  margin-left: 0px;
  position: relative;
  top: 3px;
}

.label {
  display: inline-block;

  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
}

.y_col_flex {
  min-width: 300px;
  max-width: 600px;
  display: flex;
}

.y_col_flex .label {
  height: 40px;
  line-height: 40px;
  align-self: center;
}

.y_remark_flex {
  display: flex;

  position: relative;
  align-items: baseline;
}

.y_remark_flex .label {
  height: 25px;
  line-height: 25px;
}

.y_remark {
  display: flex;
  flex: 1;
  height: 20px;
  align-items: center;
  flex-shrink: 0;
  font-size: 12px;
  color: #606266;
  cursor: pointer;
}

.y_remark span {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.y_remark_able {
  max-width: 1000px;
  background: #303133;
  position: absolute;
  top: -66px;
  left: 0;
  font-size: 12px;
  color: #ffffff;
  border-radius: 5px;
  z-index: 999999999 !important;
}
.y_remark_able span {
  display: inline-block;
  padding: 10px 10px;
}

.value {
  display: inline-block;
  width: 160px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
}
.operateBtn-wrap {
  margin-top: 0px;
}
.margin20 {
  margin-top: 10px;
}
.order_product_wrap {
  margin-top: 20px;
}

.order_item_title {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}

.order_product_table {
  height: auto;
  max-height: 400px;
  margin-bottom: 10px;
}

.order_part_table {
  margin-bottom: 10px;
}

.greenBtn {
  color: green;
}
.redBtn {
  color: red;
  width: 28px;
  height: 14px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  vertical-align: middle;
}
.table_item_text {
  height: 32px;
  line-height: 32px;
  /* padding-left: 15px; */
}
.delete {
  width: 18px;
  height: 19px;
  background-image: url("/static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}

.delete:hover {
  background-image: url("/static/img/del-hover.png");
  background-repeat: no-repeat;
}

@media screen and (max-width: 1366px) {
  .redBtn {
    font-size: 12px;
  }
}
</style>

<style>
@media screen and (min-width: 1441px) {
  .order_table {
    max-height: 230px !important;
  }

  .order_table .el-table__body-wrapper {
    max-height: 190px !important;
    overflow: auto;
  }
  /* .order_part_table {
			height: 350px;
		} */
  /* .order_part_table .el-table__body-wrapper {
			max-height: 280px !important ;
			overflow-y: auto !important ;
		} */
}

@media screen and (max-width: 1440px) and (min-width: 1367px) {
  .order_table {
    max-height: 250px !important;
  }
  .order_table .el-table__body-wrapper {
    max-height: 185px !important;
    overflow: auto;
  }
  /* .order_part_table {
			height: 285px !important;
			margin-bottom: 50px;
		} */
  /* .order_part_table .el-table__body-wrapper {
			max-height: 205px !important;
			overflow-y: auto !important ;
		} */
  #orderItemView .el-button--small,
  .el-button--small.is-round {
    padding: 9px 12px;
  }
}

@media screen and (max-width: 1366px) {
  .order_table {
    max-height: 250px !important;
  }
  .order_table .el-table__body-wrapper {
    max-height: 185px !important;
    overflow: auto;
  }
  #orderMgt {
    max-height: 700px;
  }

  #orderItemView {
    height: 106%;
  }
  /* .order_part_table {
			height: 300px !important;
			
		} */
  /* .order_part_table .el-table__body-wrapper {
			max-height: 204px;
			overflow-y: auto;
		} */
  #orderItemView .el-input {
    width: auto;
  }
  #store-time .el-date-editor.el-input,
  #store-time .el-date-editor.el-input__inner {
    width: 180px !important;
  }
}

.printModel-table .el-form-item--mini.el-form-item,
.printModel-table .el-form-item--small.el-form-item {
  margin-bottom: 26px;
}
.el-table--small .test-margin {
  padding: 20px 0 0 0 !important;
}
.cell-class .cell {
  position: relative;
  top: -12px;
  left: 4px;
}
.head-cell-class .cell {
  margin-left: 5px;
}
.ellipsis-text .el-form-item__content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/order/SalesOrder/OrderProductView.vue